import { render, staticRenderFns } from "./AisDetail.vue?vue&type=template&id=3c102882&scoped=true"
import script from "./AisDetail.vue?vue&type=script&lang=js"
export * from "./AisDetail.vue?vue&type=script&lang=js"
import style0 from "./AisDetail.vue?vue&type=style&index=0&id=3c102882&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c102882",
  null
  
)

export default component.exports